import type {
  AdditionFieldsState,
} from 'app/store/project/addition-fields/addition-fields.reducer';
import type { CourierChainsState } from 'app/store/project/courier-chains/courier-chains.reducer';
import type { CouriersState } from 'app/store/project/couriers/couriers.reducer';
import type { CurrenciesState } from 'app/store/project/currencies/currencies.reducer';
import type {
  CurrentProjectState,
} from 'app/store/project/current-project/current-project.reducer';
import type { DocumentsState } from 'app/store/project/documents/documents.reducer';
import type { ExtensionsState } from 'app/store/project/extensions/extensions.reducer';
import type { OrderFieldMapState } from 'app/store/project/field-map/field-map.reducer';
import type {
  FilterTemplatesState,
} from 'app/store/project/filter-templates/filter-templates.reducer';
import type { GoodsState } from 'app/store/project/goods/goods.reducer';
import type { NoticesState } from 'app/store/project/notices/notices.reducer';
import type { PageCriteriaState } from 'app/store/project/page-criteria/page-criteria.reducer';
import type { PoolsState } from 'app/store/project/pools/pools.reducer';
import type {
  ProgressesBackLinksState,
} from 'app/store/project/progresses-back-links/progresses-back-links.reducer';
import type {
  ProjectResourcesState,
} from 'app/store/project/project-resources/project-resources.reducer';
import type {
  ReadyProgressesState,
} from 'app/store/project/ready-progresses/ready-progresses.reducer';
import type {
  ScheduledTasksState,
} from 'app/store/project/scheduled-tasks/scheduled-tasks.reducer';
import type { SendersState } from 'app/store/project/senders/senders.reducer';
import type { StatusChainsState } from 'app/store/project/status-chains/status-chains.reducer';
import type { StatusesState } from 'app/store/project/statuses/statuses.reducer';
import type { StorehousesState } from 'app/store/project/storehouses/storehouses.reducer';
import { createFeatureSelector } from '@ngrx/store';
import {
  initialAdditionalFieldsState,
} from 'app/store/project/addition-fields/addition-fields.reducer';
import { initialCourierChainsState } from 'app/store/project/courier-chains/courier-chains.reducer';
import { initialCouriersState } from 'app/store/project/couriers/couriers.reducer';
import { initialCurrenciesState } from 'app/store/project/currencies/currencies.reducer';
import {
  initialCurrentProjectState,
} from 'app/store/project/current-project/current-project.reducer';
import { initialDocumentsState } from 'app/store/project/documents/documents.reducer';
import { initialExtensionsState } from 'app/store/project/extensions/extensions.reducer';
import { initialFieldMapState } from 'app/store/project/field-map/field-map.reducer';
import {
  initialFilterTemplatesState,
} from 'app/store/project/filter-templates/filter-templates.reducer';
import { initialGoodsState } from 'app/store/project/goods/goods.reducer';
import { initialNoticesState } from 'app/store/project/notices/notices.reducer';
import { initialPageCriteriaState } from 'app/store/project/page-criteria/page-criteria.reducer';
import { initialPoolsState } from 'app/store/project/pools/pools.reducer';
import {
  initialProgressesBackLinksState,
} from 'app/store/project/progresses-back-links/progresses-back-links.reducer';
import {
  initialProjectResourcesState,
} from 'app/store/project/project-resources/project-resources.reducer';
import {
  initialReadyProgressesState,
} from 'app/store/project/ready-progresses/ready-progresses.reducer';
import {
  initialScheduledTasksState,
} from 'app/store/project/scheduled-tasks/scheduled-tasks.reducer';
import { initialSendersState } from 'app/store/project/senders/senders.reducer';
import { initialStatusChainsState } from 'app/store/project/status-chains/status-chains.reducer';
import { initialStatusesState } from 'app/store/project/statuses/statuses.reducer';
import { initialStorehousesState } from 'app/store/project/storehouses/storehouses.reducer';

export const projectFeatureKey = 'project';

export const selectProjectState = createFeatureSelector<ProjectState>(projectFeatureKey);

export interface ProjectState {
  additionFields: AdditionFieldsState;
  couriers: CouriersState;
  courierChains: CourierChainsState;
  documents: DocumentsState;
  pools: PoolsState;
  goods: GoodsState;
  scheduledTasks: ScheduledTasksState;
  senders: SendersState;
  statuses: StatusesState;
  statusChains: StatusChainsState;
  storehouses: StorehousesState;
  currentProject: CurrentProjectState;
  orderFieldMap: OrderFieldMapState;
  filterTemplates: FilterTemplatesState;
  currencies: CurrenciesState;
  pageCriteria: PageCriteriaState;
  progressesBackLinks: ProgressesBackLinksState;
  projectResources: ProjectResourcesState;
  notices: NoticesState;
  extensions: ExtensionsState;
  readyProgresses: ReadyProgressesState;
}

export const initialProjectState: ProjectState = {
  additionFields: initialAdditionalFieldsState,
  couriers: initialCouriersState,
  courierChains: initialCourierChainsState,
  documents: initialDocumentsState,
  pools: initialPoolsState,
  goods: initialGoodsState,
  scheduledTasks: initialScheduledTasksState,
  senders: initialSendersState,
  statuses: initialStatusesState,
  statusChains: initialStatusChainsState,
  storehouses: initialStorehousesState,
  currentProject: initialCurrentProjectState,
  orderFieldMap: initialFieldMapState,
  filterTemplates: initialFilterTemplatesState,
  currencies: initialCurrenciesState,
  pageCriteria: initialPageCriteriaState,
  progressesBackLinks: initialProgressesBackLinksState,
  projectResources: initialProjectResourcesState,
  notices: initialNoticesState,
  extensions: initialExtensionsState,
  readyProgresses: initialReadyProgressesState,
};
